import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  provider_list: [],
  selectProvider: '',
  sliderPosition: 0,
  sliderindex:0,
  all_provider_list:[]
};

const providerStateSlice = createSlice({
  name: 'provider',
  initialState: initialState,
  reducers: {
    listProvider: (state, action) => {
      state.provider_list = action.payload
    },
    resetListProvider: (state, action) => {
      state.provider_list = []
    },
    selectProvider: (state, action) => {
      // console.log(action);
      state.selectProvider = action.payload;
    },
    removeProviderDetails: (state, action) => {
      state.selectProvider = "";
    },
     selectSlider: (state, action) => {
      state.sliderPosition = action.payload;
    },
    selectSliderIndex: (state, action) => {
      state.sliderindex = action.payload;
    },
    allProviderList: (state, action) => {
      state.all_provider_list = [...action.payload]
    },
  }
});

export const { listProvider, resetListProvider, selectProvider, removeProviderDetails, selectSlider, selectSliderIndex,allProviderList } = providerStateSlice.actions;

export default providerStateSlice.reducer;